import { render, staticRenderFns } from "./FeedbackView.vue?vue&type=template&id=88255ad0"
import script from "./FeedbackView.vue?vue&type=script&lang=ts"
export * from "./FeedbackView.vue?vue&type=script&lang=ts"
import style0 from "./FeedbackView.vue?vue&type=style&index=0&id=88255ad0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports